import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { toast } from "sonner";
import { Check, X, MessageSquare } from "lucide-react";
import { Link } from "react-router-dom";

const statusColors = {
    PENDING: "bg-amber-50 text-amber-700 border-amber-200",
    ACCEPTED: "bg-emerald-50 text-emerald-700 border-emerald-200",
    REJECTED: "bg-rose-50 text-rose-700 border-rose-200",
    WITHDRAWN: "bg-gray-50 text-gray-700 border-gray-200",
};

export default function FacilityApplications() {
    const [apps, setApps] = useState([]);
    const load = async () => {
        const { data } = await api.get("/applications");
        setApps(data.data || []);
    };
    useEffect(() => { load(); }, []);

    const setStatus = async (id, status) => {
        try {
            await api.patch(`/applications/${id}`, { status });
            toast.success(status === "ACCEPTED" ? "Candidatura accettata" : "Candidatura rifiutata");
            load();
        } catch (e) { toast.error("Errore"); }
    };

    return (
        <div className="max-w-5xl mx-auto">
            <h1 className="font-display text-3xl font-bold tracking-tight">Candidature ricevute</h1>
            <p className="text-sm text-[#5C5C5C] mt-1 mb-6">{apps.length} totali</p>
            <div className="space-y-3">
                {apps.length === 0 && <div className="hl-card p-10 text-center text-[#5C5C5C]">Nessuna candidatura ancora.</div>}
                {apps.map((a) => (
                    <div key={a.id} className="hl-card p-5" data-testid={`fac-app-${a.id}`}>
                        <div className="flex items-start justify-between gap-4">
                            <div className="flex-1">
                                <div className="flex items-center gap-2">
                                    <div className="font-display font-bold">{a.professional_name}</div>
                                    <span className="text-xs text-[#5C5C5C]">· {a.professional_profession}</span>
                                </div>
                                <div className="text-sm text-[#5C5C5C]">Per: <span className="font-medium text-[#1A1A1A]">{a.job_title}</span></div>
                                {a.message && <div className="mt-2 text-sm p-3 bg-[#F9F9F7] rounded-md">{a.message}</div>}
                                <div className="mt-2 flex items-center gap-2 text-xs text-[#5C5C5C]">
                                    <span>Match {a.match_score}%</span>
                                    <span>·</span>
                                    <span>{new Date(a.created_at).toLocaleDateString("it-IT")}</span>
                                </div>
                            </div>
                            <div className="flex flex-col items-end gap-2">
                                <Badge variant="outline" className={statusColors[a.status]}>{a.status}</Badge>
                                {a.status === "PENDING" && (
                                    <div className="flex gap-2">
                                        <Button size="sm" onClick={() => setStatus(a.id, "ACCEPTED")}
                                            className="bg-[#1C3F39] hover:bg-[#2A5C53]" data-testid={`accept-${a.id}`}>
                                            <Check className="w-4 h-4 mr-1" />Accetta
                                        </Button>
                                        <Button size="sm" variant="outline" onClick={() => setStatus(a.id, "REJECTED")} data-testid={`reject-${a.id}`}>
                                            <X className="w-4 h-4 mr-1" />Rifiuta
                                        </Button>
                                    </div>
                                )}
                                <Link to="/app/chat"><Button size="sm" variant="ghost"><MessageSquare className="w-4 h-4 mr-1" />Chat</Button></Link>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
